module.exports = __webpack_public_path__ + "img/4_.2ef94744.svg";